module.exports = __webpack_public_path__ + "img/tuna.78bc1aa9.png";